import { themeObject } from 'lib';

export const dataCardStyles = {
    root: {
        p: 0,
        border: `1px solid ${themeObject.palette.grayScale[200]}`,
        m: { xs: 1, sm: 0 },
        padding: 3,
        borderRadius: '5px',
        flexGrow: 1,
    },
    insightLabel: {
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'center',
        color: themeObject.palette.grayScale.A400,
        fontSize: '14px',
        fontFamily: 'Red Hat Mono',
    },
    insightValue: {
        fontFamily: 'Raleway',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '40px',
        color: themeObject.palette.primary[500],
        textTransform: 'uppercase' as const,
        display: 'flex',
        justifyContent: 'center',
        mt: 2,
        fontVariantNumeric: 'lining-nums',
    },
    noData: {
        color: themeObject.palette.grayScale[500],
    },
};

export const dataDisabledCardStyles = {
    container: {
        border: `1px solid ${themeObject.palette.grayScale[200]}`,
        borderRadius: '5px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        p: '18.59px 20.14px 12px 20px',
        backgroundColor: themeObject.palette.background.default,
        m: { xs: 1, sm: 0 },
        flexGrow: 1,
    },
    headingTextStyles: {
        fontFamily: 'Red Hat Mono',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '100%',
        letterSpacing: '0.5px',
        textTransform: 'uppercase',
        color: themeObject.palette.grayScale[700],
        mb: '8.41px',
        textAlign: 'center',
    },
    subheadingTextStyles: {
        fontFamily: 'Red Hat Text',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '100%',
        letterSpacing: '0.4px',
        color: themeObject.palette.grayScale[600],
        mt: 1,
        textAlign: 'center',
    },
    popperStyles: {
        width: '124px',
        height: '56px',
    },
    helpIconTooltipStyles: {
        '& .MuiSvgIcon-root': {
            height: '12px',
            width: '12px',
        },
    },
    helpIconWithTextStyles: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        whiteSpace: 'nowrap',
    },
};
